export const paymentRuns: TableModule = {
    name: "paymentRuns",
    route: "spa.payments.paymentRuns",
    defaultOrder: {
        column: "id",
        direction: "desc"
    },
    columns: [
        {
            name: "id",
            sortBy: "payment_runs.id",
            sortable: true,
            pageLink: true,
            mobile: true,
            width: "md:w-[100px]"
        },
        {
            name: "funding_program",
            sortable: true,
            sortBy: "funding_program_id",
            width: "w-auto",
            breakpoint: 'md',
        },
        {
            name: "organisation",
            sortable: true,
            sortBy: "organisation_id",
            width: "w-auto",
        },
        {
            name: "intended_use",
            sortable: true,
            breakpoint: 'lg',
        },
        {
            name: "sum",
            sortable: true,
            width: "w-auto xl:w-[150px]",
        },
        {
            name: "created_at",
            sortable: true,
            breakpoint: 'xl',
        },
        {
            name: "properties",
            width: "w-[150px]",
            mobile: true,
        },
    ],
    filters: [],
    quickFilters: [],
    tools: []
}